














































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import CustomConversionsApi from '@/services/rest/bemob/custom-conversions';
import ReportAPI from '@/services/rest/bemob/report';
import {METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE, METRICS_CUSTOM_EVENT_HIDDEN_REVENUE} from '@/services/constants/report';

@Component({})
export default class CustomConversions extends Vue {
  customConversionsApi: CustomConversionsApi = new CustomConversionsApi();
  reportApi: ReportAPI = new ReportAPI();
  loading: boolean = true;
  showArchived: boolean = false;
  rows: any = [];
  activeCustomEvents: any = [];
  rowsOnPage: number = 10;
  pagination: any = {
    rowsPerPage: this.rowsOnPage
  };

  get headers() {
    return [
      {
        text: this.t('Custom Event'),
        align: 'left',
        value: 'name',
        sortable: true
      },
      {
        text: this.t('Parameter Values'),
        align: 'left',
        value: 'values',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        value: '',
        sortable: false
      }
    ]
  }

  get filteredRows() {
    if(this.showArchived){
      return this.rows;
    }
    return this.rows.filter((item:any)=>item.status ==='active')
  }

  openCreateCustomConversions(item:any) {
    this.bus.emit('open-dialog', { name: 'CreateCustomConversions', data: item });
  }

  load(): any {
    const customConversionsApi: Promise<any> = this.customConversionsApi.get().then((data:any)=>this.$store.commit('tableCustomEvents', data));
    return Promise.all([customConversionsApi])
  }

  mounted() {
    this.$store.commit('loading', true);
    this.load().then(() => {
      this.loading = false;
      this.$store.commit('loading', false);
    });
  }

  archiveRestoreConfirm(item:any) {
    if (item.status === 'active') {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('All selected items will be archived if you press OK. You can restore them anytime.'),
        onConfirm: () => this.archiveRestore(item),
      }})
    } else {
      this.archiveRestore(item)
    }
  }

  archiveRestore(item:any) {
    const newStatus = item.status === 'active' ? 'archived' : 'active';
    return this.customConversionsApi.put({
      ...item,
      status:newStatus
    })
    .then(()=>{
      this.customConversionsApi.get().then((data:any)=> {
        if (item.status === 'active') {
          this.$store.dispatch('omitReportsColumns', [METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE,METRICS_CUSTOM_EVENT_HIDDEN_REVENUE].map(prefix => `${prefix}${item.slug}`))
        }

        this.$store.commit('tableCustomEvents', data)
      });
      const text = item.status === 'active'
        ? this.t('The event archived successfully')
        : this.t('The event restored successfully');
      this.bus.emit('toast-success', text);

      this.reportApi.getSupportedMetrics()
    })
    .catch((error) => {
      this.bus.emit('toast-error', this.t(error.response.data.message));
      return Promise.reject(error);
    })
  }

  generateLinks(data) {
    this.$store.commit('loading', true);
    this.bus.emit('open-dialog', { name: 'GenerateLinks', data });
  }

  @Watch('$store.state.table.customEvents')
  updateRows(data: any) {
    this.rows = Object.values(data);

    this.activeCustomEvents = this.rows.filter((item:any)=>item.status !== 'archived')
  }
}
